<template>
    <div class="xhrank2023">
        <div class="main">
            <div class="myinfo">
                <div>
                    <div>
                        <div class="myavatar">
                            <VanImage :src="myinfo.avatar" />
                        </div>
                        <div class="myrank">
                            <template v-if="+myinfo.rank > 0">排名 {{ myinfo.rank }}</template>
                            <template v-else>暂无排名</template>
                        </div>
                    </div>
                    <div>{{ myinfo.nickname }}</div>
                    
                </div>
                <div>
                    <div>{{myinfo.steps}} 步</div>
                </div>
            </div>
            <List
            style="color:#FFF;"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="init"
            >
                <div class="rank-list">
                    <CellGroup style="border-radius:.16rem" v-if="rankList.length" :border="false">
                    <Cell v-for="item in rankList" :key="item.id" center  class="rank">
                        <div slot="title">{{item.name||item.nickname}}</div>
                        <div slot="icon" class="rank_icon">
                        <template v-if="item.rank <= 3">
                            <img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
                            <img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
                            <img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
                        </template>

                        <span v-else>{{ item.rank }}</span>
                        <VanImage :src="item.avatarurl" />
                        </div>


                        <span> {{ item.steps }}</span>

                    </Cell>
                    </CellGroup>
                    <Empty
                    style="background: #fff;min-height: 6rem;border-radius:.16rem"
                    v-else
                    description="暂无数据"
                    />
                </div>
            </List>
        </div>
        
    </div>
</template>
<script>
import moment from "moment";
import "./index.less";

import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup, Sticky } from "vant";
export default {
    components: {
        Empty,
        Panel,
        Cell,
        CellGroup,
        List,
        VanImage: Image,
        Row,
        Col,
        Popup,Sticky
    },
    data() {
        return {
            page: 1,
            loading: false,
            finished: false,
            myinfo: {},
            rankList: []
        }
    },
    watch: {
        active(newvalue, oldvalue) {
            this.page = 1
            this.loading = false
            this.finished = false
            this.init()             
        },
    },
    methods: {
        init() {
            this.$api.activity
            .steprank(
                Object.assign({
                activity_id: this.$route.params.activity_id,
                page: this.page
                })
            )
            .then((res) => {
                if (+res.status !== 200) {
                this.finished = true;
                return;
                }
                this.systime = res.sys_time;
                this.loading = false;
                let {
                list,
                page,
                pages,
                myinfo
                } = res.data;
                this.myinfo = myinfo;
                this.rankList = list;

                let t = null

                this.rankList.forEach((item, index) => {
                    if(t == null){
                        t =  item;
                        t.rank = index+1;
                    }else{
                        var n = item;
                        if(n.steps*1 == t.steps*1){
                            n.rank = t.rank;
                        }else{
                            n.rank = index+1;
                        }
                        t = n;
                    }
                })
                this.finished = true;
            });
        }
    }
}
</script>